import { useEffect } from "react";

const SUFFIX = " · PadPulse";

/**
 * Sets the browser tab title.
 * @param pageTitle - Short page name (e.g. "Dashboard"). The suffix " · PadPulse" is appended automatically.
 *                    Pass `null` or `undefined` to leave the title unchanged.
 * @param raw       - When `true`, `pageTitle` is used as-is without appending the suffix.
 *                    Useful for pages that manage their own full title string.
 */
export function usePageTitle(pageTitle: string | null | undefined, raw?: boolean) {
  useEffect(() => {
    if (!pageTitle) return;
    const prev = document.title;
    document.title = raw ? pageTitle : `${pageTitle}${SUFFIX}`;
    return () => {
      document.title = prev;
    };
  }, [pageTitle, raw]);
}
